var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21.132812pt",
    height: "69.492188pt",
    viewBox: "0 0 21.132813 69.492187",
    id: "svg312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g313",
    transform: "translate(-340.61328,-37.253906)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 454.5625,137.4375 0.15625,1.125 0.47917,1.1198 0.64062,0.95833 0.96354,0.64062 1.11979,0.47917 1.1198,0.16146",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path19"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 459.04167,142.07813 h 23.03645 V 49.92188 h -23.03645",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 459.04167,50.07813 -1.1198,0.161459 -1.11979,0.479166 -0.96354,0.640625 -0.64062,0.958334 -0.47917,1.119791 -0.15625,1.125",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 454.40104,54.562505 V 137.4375",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 456.80208,137.4375 v 0.64063 l 0.31771,0.48437 0.31771,0.47917 0.48437,0.31771 0.47917,0.32292 h 0.64063",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 459.04167,139.6823 h 4.64062 V 52.161464 h -4.64062",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 459.04167,52.317714 h -0.64063 l -0.47917,0.322916 -0.48437,0.317709 -0.31771,0.479166 -0.31771,0.484375 v 0.640625",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00209533,0.00250433 V 82.877504 M 6.882304,85.122296 V -2.398537 m 16,52.958333 H 9.121887 M 22.882304,32.158754 H 9.121887",
    transform: "matrix(0.75,0,0,0.75,342.59999,40.919997)",
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 479.68229,52.161464 V 139.6823 H 465.92187 V 52.161464 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path27"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 10.624994,67.507812 V 1.8671873 M 12.308588,67.507812 V 1.8671873 M 13.988276,67.507812 V 1.8671873 M 15.785151,67.507812 V 1.8671873 M 17.464838,67.507812 V 1.8671873 M 19.148432,13.984375 H 8.8281195 M 19.148432,55.386718 H 8.8281195 M 80.82812,778.26563 H 38.945307 m -6.238281,0 h -6.242188 m -6.238281,0 h -6.238281 m -6.2421875,0 H -23.332036 m -6.242188,0 h -6.238281 m -6.242188,0 h -6.238281 m -6.242188,0 h -31.199214 m -6.238283,0 h -6.24219 m -6.238281,0 h -6.1211",
    id: "path28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirin);
export default __webpack_public_path__ + "static/media/airin.219bcbf02fa50fbbb4b791c5c37a453d.svg";
export { ForwardRef as ReactComponent };